//Modules
import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';


//Components
import { useHeroImage } from './HeroImageContext';
import { useHeroTextAnimation } from '../globalComponents/UseTextAnimation';

const HeroImage = ({ isLoaded }) => {
  const { heroImage } = useHeroImage();
  const imageRef = useRef(null);

  useEffect(() => {
    if (!isLoaded) return;
    if (!imageRef.current) return;

    gsap.fromTo(
      imageRef.current,
      { clipPath: "inset(100% 0% 0% 0%)" },
      {
        clipPath: "inset(0% 0% 0% 0%)",
        duration: 1.5,
        ease: "power4.inOut",
        delay: 0.5,
      }
    );
  }, [isLoaded]);

  return (
    <div className="hero-image-container">
      <div
        className="hero-image"
        ref={imageRef}
        style={{ backgroundImage: `url(${heroImage})` }}
      />
    </div>
  );
};

export const HeroContent = ({ isLoaded }) => {
  const { heroText } = useHeroImage();
  const { captionRef, titleRef, descriptionRef, animateIn } = useHeroTextAnimation();

  useEffect(() => {
    if (!isLoaded) return;
    requestAnimationFrame(() => {
      animateIn();
    });
  }, [isLoaded, animateIn]);

  useEffect(() => {
    if (!isLoaded) return;
    requestAnimationFrame(() => {
      animateIn();
    });
  }, [heroText, animateIn, isLoaded]);


return (
    <div className="project-snippet">
      <p className="caption" ref={captionRef}>{heroText.caption}</p>
      <div className="project-description">
        <p className="body-bold" ref={titleRef}>{heroText.title}</p>
        <p className="body" ref={descriptionRef}>{heroText.description}</p>
      </div>
    </div>
  );
};


export default HeroImage;